import React from 'react';
import { StageUploadsAccordion } from './StageUploadsAccordion';
import { useQuery } from '@tanstack/react-query';
import { leadUploadService } from '../../../client_contact_stages/verve-design/services/leadUploadService';

export const UploadDocumentsAccordion = ({ lead, onPreview }) => {
  const { data: uploadsData } = useQuery({
    queryKey: ['lead-uploads', lead?._id],
    queryFn: async () => {
      if (!lead?._id) return null;
      const res = await leadUploadService.getFilesByLead(lead._id);
      return res.data?.data?.files || res.data?.files || [];
    },
    enabled: !!lead?._id,
  });

  if (!lead) return null;

  const leadUploads = uploadsData || [];

  // Filter LeadUpload files matching "Upload Documents If Any" or generic upload
  const uploadsFromService = leadUploads.filter(f => 
    f.type === 'Upload Documents If Any' || 
    f.type === 'upload' || 
    (!f.type && f.stage === 'Upload Documents If Any')
  );

  // Check direct properties on lead object
  const uploadsFromLeadFiles = (lead.uploadedFiles || lead.files || []).filter(f => 
    f && (f.stage === 'Upload Documents If Any' || f.type === 'Upload Documents If Any' || f.type === 'upload')
  );

  const uploadsFromDesignMedia = (lead.designMedia || []).filter(f => 
    f && (f.stage === 'Upload Documents If Any' || f.type === 'Upload Documents If Any')
  );

  // Deduplicate files by fileId or _id
  const seenIds = new Set();
  const allFiles = [];

  [...uploadsFromService, ...uploadsFromLeadFiles, ...uploadsFromDesignMedia].forEach(file => {
    const id = file.fileId || file._id || file.url || file.filename || JSON.stringify(file);
    if (!seenIds.has(id)) {
      seenIds.add(id);
      allFiles.push({
        ...file,
        downloadPrefix: file.downloadPrefix || '/api/lead-uploads/stream'
      });
    }
  });

  return (
    <StageUploadsAccordion 
      title="Upload Documents If Any" 
      files={allFiles} 
      colorTheme="slate" 
      onPreview={onPreview} 
      downloadPrefix="/api/lead-uploads/stream" 
    />
  );
};
